import styled from 'styled-components'
import { GRID_COLUMNS } from './constants'

export const HeaderText = styled.div`
  margin-bottom: 1em;
  padding: 5px 10px;
  background: rgb(255, 255, 255);
  border: 1px solid rgb(236, 236, 241);
  border-radius: 12px;
  width: fit-content;
`

export const FooterText = styled.div`
  margin-top: 1em;
  padding: 5px 10px;
  background: rgb(255, 255, 255);
  border: 1px solid rgb(236, 236, 241);
  width: fit-content;
  border-radius: 12px;
`

/* Unified grid that mixes read-only and editable cells in Form.Group rows. */
export const UnifiedGrid = styled.div`
  .fields {
    margin-bottom: 0 !important;
  }
  .field {
    margin-bottom: 5px !important;
  }

  /* Compact density: shorter inputs and tighter labels to reduce row height. */
  .field > label {
    font-size: 12px !important;
    margin-bottom: 2px !important;
  }
  /* Semantic dims the label of a disabled (read-only) field to 0.45 — keep it full.
     It also sets pointer-events:none on the disabled field, which kills the info-icon
     hover, so re-enable pointer events on the label only (input stays disabled). */
  .field.disabled > label {
    opacity: 1 !important;
    pointer-events: auto !important;
  }
  .ui.input > input,
  .ui.input input,
  .field input[type='text'],
  .field input[type='number'],
  .field input:not([type]) {
    padding-top: 7px !important;
    padding-bottom: 7px !important;
    min-height: 32px !important;
    font-size: 13px !important;
  }
  .ui.selection.dropdown {
    min-height: 32px !important;
    padding-top: 8px !important;
    padding-bottom: 8px !important;
    font-size: 13px !important;
  }
  .ui.selection.dropdown > .dropdown.icon {
    padding-top: 9px !important;
    padding-bottom: 9px !important;
  }
  /* Phone fields: keep the prefix dropdown label aligned with the slimmer input. */
  .ui.labeled.input > .label {
    padding-top: 7px !important;
    padding-bottom: 7px !important;
  }

  /* Read-only fields are rendered as disabled inputs: muted but still legible. */
  .ui.input.disabled,
  .ui.disabled.input,
  .ui.disabled.dropdown,
  .field .ui.disabled.selection.dropdown,
  input:disabled {
    opacity: 1 !important;
    label {
      color: rgba(0,0,0,.87) !important;
    }
  }
  .ui.input.disabled > input,
  .ui.disabled.input > input,
  input:disabled,
  .ui.disabled.selection.dropdown {
    background: #f4f6f8 !important;
    color: rgba(0, 0, 0, 0.6) !important;
    border-color: #e3e8ee !important;
    -webkit-text-fill-color: rgba(0, 0, 0, 0.6) !important;
    label {
      color: rgba(0,0,0,.87) !important;
    }
  }
`

export const TermsSection = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  gap: 10px;
`

export const TermsLinks = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px 16px;
`

export const TermsLink = styled.a`
  cursor: pointer;
  color: #2185d0;
  text-decoration: underline;
  font-size: 13px;

  &:hover {
    opacity: 0.85;
  }
`

export const CategorySection = styled.div`
  background: #ffffff;
  border: 1px solid #ececf1;
  border-radius: 12px;
  padding: 15px 18px;
  margin-bottom: 10px;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);

  .disabled {
    opacity: 1 !important;
  }
`

export const CategoryTitle = styled.div`
  display: flex;
  align-items: center;
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: ${props => props.theme?.firstColor};
  margin-bottom: 10px;

  i.icon {
    width: 28px;
    height: 28px;
    margin: 0 !important;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    color: ${props => props.theme?.firstColor};
    font-size: 1.1em;
  }

  &.farms i.icon {
    color: ${props => props.theme?.firstColor};
  }

  .bracket-values {
    font-weight: 500 !important;
    font-size: 14px !important;
    text-transform: none !important;
  }
`

export const ReadOnlyCard = styled.div`
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 4px;
  padding: 12px 16px;
  margin-bottom: 12px;

  .ui.form .fields,
  && .fields {
    margin-bottom: 0;
  }
  .field {
    margin-bottom: 0 !important;
  }
`

export const ReadOnlyLabel = styled.div`
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
  margin-bottom: 2px;
`

export const ReadOnlyValue = styled.div`
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
`

export const EditableSection = styled.div`
  /* Each input is a grid cell that flows ${GRID_COLUMNS}-per-row, so a two-input field
     (street/city) simply takes two consecutive cells and may wrap across rows. */
  display: grid;
  grid-template-columns: repeat(${GRID_COLUMNS}, 1fr);
  column-gap: 16px;
  align-items: start;

  /* Tighten semantic-ui's default 1em field margin for denser rows. */
  .field {
    margin-bottom: 10px !important;
  }
`

export const FarmerTableHeader = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px;
  padding: 8px 12px;
  background: #f7f8fa;
  border: 1px solid #ececf1;
  border-radius: 8px 8px 0 0;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.55);
`

export const FarmerCard = styled.div`
  border: 1px solid rgb(244, 246, 248);
  border-width: 20px 1px !important;
  border-top: none;
  padding: 10px 12px;
  background: #ffffff;

  &:last-child {
    border-radius: 0 0 8px 8px;
  }
`

export const FarmerCardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 14px;
  padding-bottom: 10px;
  border-bottom: 1px 3px solid rgba(34, 36, 38, 0.08);
`

export const FarmerStatusDot = styled.span`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: ${props => props.theme?.firstColor};
  flex-shrink: 0;
`

export const FarmerCompanyName = styled.span`
  color: ${props => props.theme?.firstColor};
`

export const FarmerAgisId = styled.span`
  color: rgba(0, 0, 0, 0.45);
  font-weight: 400;
  font-size: 13px;
  margin-left: 2px;
`

export const FarmerReadOnly = styled.div`
  padding-top: 2px;
  margin-bottom: 1em;

  .fields {
    margin-bottom: 0 !important;
  }
  .field {
    margin-bottom: 0 !important;
  }
`
